import { GET_DEMANDS_BY_DEMAND_IDS, LOAD } from '@/store/actionTypes';
import { GET_ORDERS } from '@/store/getterTypes';
import {
  FAILED,
  LOADING,
  REPLACE,
  SET_PURCHASE_ORDER_DEMANDS_FAILED,
  SET_PURCHASE_ORDER_DEMANDS_LOADING,
  MATCH_DEMAND_TO_ORDER,
} from '@/store/mutationTypes';
import ApiLoadingStatus from '@/api/statusTypes';
import purchaseOrderApi from 'src/api/server/purchaseOrders';
import { GET_OFFERS_BY_OFFER_IDS } from '@/store/actionTypes';
import {
  MATCH_OFFER_TO_ORDER,
  SET_PURCHASE_ORDER_OFFERS_FAILED,
  SET_PURCHASE_ORDER_OFFERS_LOADING,
} from '@/store/mutationTypes';
// eslint-disable-next-line no-unused-vars
import { endOfDay, format, parseISO, startOfDay } from 'date-fns';

export default {
  namespaced: true,
  state() {
    return {
      purchaseOrdersMap: {},
      status: ApiLoadingStatus.STATUS_NOT_INITIALIZED,
      purchaseOrdersDemandsStatus: null,
      purchaseOrdersOffersStatus: null,
      purchaseOffers: {},
    };
  },
  mutations: {
    [REPLACE](state, purchaseOrders) {
      state.purchaseOrdersMap = {};
      if (purchaseOrders && purchaseOrders.length > 0) {
        for (let purchaseOrder of purchaseOrders) {
          state.purchaseOrdersMap = {
            ...state.purchaseOrdersMap,
            [purchaseOrder.demandId]: purchaseOrder,
          };
        }
      }
      state.status = ApiLoadingStatus.STATUS_SUCCESSFUL;
    },
    [FAILED](state) {
      state.purchaseOrdersMap = {};
      state.status = ApiLoadingStatus.STATUS_ERROR_LOADING;
    },
    [LOADING](state) {
      state.status = ApiLoadingStatus.STATUS_LOADING;
    },
    [MATCH_DEMAND_TO_ORDER](state, demands) {
      state.purchaseOrdersDemandsStatus = ApiLoadingStatus.STATUS_SUCCESSFUL;
      if (demands && demands.length === 0) {
        return;
      }
      for (let demand of demands) {
        state.purchaseOrdersMap = {
          ...state.purchaseOrdersMap,
          [demand.demandId]: {
            ...state.purchaseOrdersMap[demand.demandId],
            demand,
          },
        };
      }
    },
    [MATCH_OFFER_TO_ORDER](state, offers) {
      state.purchaseOrdersOffersStatus = ApiLoadingStatus.STATUS_SUCCESSFUL;
      if (offers && offers.length === 0) {
        return;
      }
      for (let offer of offers) {
        state.purchaseOffers = {
          ...state.purchaseOffers,
          [offer.purchaseOfferId]: offer,
        };
      }
    },
    [SET_PURCHASE_ORDER_DEMANDS_LOADING](state) {
      state.purchaseOrdersDemandsStatus = ApiLoadingStatus.STATUS_LOADING;
    },
    [SET_PURCHASE_ORDER_DEMANDS_FAILED](state) {
      state.purchaseOrdersDemandsStatus = ApiLoadingStatus.STATUS_ERROR_LOADING;
    },
    [SET_PURCHASE_ORDER_OFFERS_LOADING](state) {
      state.purchaseOrdersOffersStatus = ApiLoadingStatus.STATUS_LOADING;
    },
    [SET_PURCHASE_ORDER_OFFERS_FAILED](state) {
      state.purchaseOrdersOffersStatus = ApiLoadingStatus.STATUS_ERROR_LOADING;
    },
  },
  actions: {
    async [LOAD]({ commit, dispatch }, { fromDate, toDate }) {
      try {
        commit(LOADING);
        let orders = await purchaseOrderApi.loadOrders(fromDate, toDate);
        orders = orders.map((order) => ({
          ...order,
          _showDetails: false,
        }));
        commit(REPLACE, orders);
        let demandIds = orders.map((order) => order.demandId);
        dispatch(GET_DEMANDS_BY_DEMAND_IDS, { demandIds: demandIds });
        let offerIds = orders.map((order) => order.purchaseOfferId);

        dispatch(GET_OFFERS_BY_OFFER_IDS, {
          // eslint-disable-next-line no-undef
          offerIds: offerIds,
        });
      } catch (e) {
        console.log(e);
        commit(FAILED);
      }
    },
    async [GET_DEMANDS_BY_DEMAND_IDS]({ commit }, payload) {
      try {
        commit(SET_PURCHASE_ORDER_DEMANDS_LOADING);
        let orders = await purchaseOrderApi.loadDemandsByIds(payload.demandIds);
        commit(MATCH_DEMAND_TO_ORDER, orders.data);
      } catch (e) {
        commit(SET_PURCHASE_ORDER_DEMANDS_FAILED);
      }
    },
    async [GET_OFFERS_BY_OFFER_IDS]({ commit }, payload) {
      try {
        commit(SET_PURCHASE_ORDER_OFFERS_LOADING);
        let orders = await purchaseOrderApi.loadOffersByIds(payload.offerIds);
        commit(MATCH_OFFER_TO_ORDER, orders.data);
      } catch (e) {
        commit(SET_PURCHASE_ORDER_OFFERS_FAILED);
      }
    },
  },
  getters: {
    [GET_ORDERS]: (state) => {
      // eslint-disable-next-line no-undef
      return Object.values(state.purchaseOrdersMap);
    },
    ['getPurchaseOffers']: (state) => {
      return state.purchaseOffers;
    },
  },
};
